"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handsOffFormToPayloadDataHandler = handsOffFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function handsOffFormToPayloadDataHandler(data) {
    const now = (0, dayjs_1.default)();
    return {
        form: Object.assign(Object.assign({ frequencyRemaining: data.frequencyRemaining, startingFromWeekOf: data.startingFromWeekOf }, (data.notes && {
            careNotesForFollowUpClinician: data.notes,
        })), { offSet: now.utcOffset() }),
    };
}
